import { action, thunkOn } from "easy-peasy";
import { message } from "antd";
import _ from "lodash";
import { onLogoutResolver } from "./on-logout-resolver";

export const NO_DEAD_OPPS_MSG =
  "No dead opportunities at this time. Please check again tomorrow";

const modelDeadOpps = {
  INITIAL_DATA_ENDPOINT: "dead_opps",
  NAME: "dead_opps",
  INCLUDE_APP_MODE_IN_INITIALDATA_REQUEST: true,
  INCLUDE_ITIN_MODE_IN_INITIALDATA_REQUEST: true,
  initialData: [],
  initialDataReceived: false,
  initialDataLoading: false,
  /////////////
  // ACTIONS //
  /////////////
  resetData: action((state) => {
    state.initialData = [];
    state.initialDataReceived = false;
    state.initialDataLoading = false;
  }),
  onLogout: thunkOn(onLogoutResolver, (actions) => {
    actions.resetData();
  }),
  receiveInitialData: action((state, payload) => {
    if (_.size(payload) === 0) {
      message.info(NO_DEAD_OPPS_MSG, 0);
    }
    state.initialData = payload;
  }),
  maybeHandleFetchInitialData: undefined,
  handleFetchInitialData: undefined,
  markInitialDataReceived: undefined,
};

export default modelDeadOpps;
